
export const sFechaPublicacion = '2023-09-07T14:44:28.1516343-06:00';
export const sVersion = 'vPanComedor0.1.09071444';
            